import { Registration as Index } from '../../components'
import React from 'react'

const Registration = (): JSX.Element => <Index />

export default Registration
